module.exports = __webpack_public_path__ + "img/202510_04.48231781.png";